import { Base } from './base';

export class Payment extends Base {
    PaymentID?: string;
    PaymentTypeID?: number;
    PaymentStatID?: number;
    PaymentMethodTypeID?: number;
    ProductID?: string;
    CurrencyID?: number;
    Amount?: number;
    Commision?: number;
    Date?: Date;
    FromFinancialAccount?: string;
    ToFinancialAccount?: string;

    // Model properties
    Currency?: string;
    FullName?: string;
    Plate?: string;
    ParkingTitle?: string;
    Location?: string;
    FromDate?: Date;
    ToDate?: Date;

    // Web properties
    PaymentIcon?: string;
    PaymentMethod?: string;
    DisplayAmount?: string;
}
